import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=284274bd&scoped=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=284274bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284274bd",
  null
  
)

export default component.exports